import React from 'react';
import PropTypes from 'prop-types';

import DateAnswer from 'components/threepp/assessment/Answers/Date/DateAnswer';
import TextAnswer from 'components/threepp/assessment/Answers/Text/TextAnswer';
import NumericAnswer from 'components/threepp/assessment/Answers/Numeric/NumericAnswer';
import CheckboxAnswer from 'components/threepp/assessment/Answers/Multivalue/CheckboxAnswer';
import RadioGroupAnswer from 'components/threepp/assessment/Answers/Option/RadioGroupAnswer';
import DropdownAnswer from 'components/threepp/assessment/Answers/Dropdown/DropdownAnswer';
import UploadAttachment from 'components/threepp/assessment/Answers/Attachments/Upload/UploadAttachment';
import UploadTemplateAttachment from 'components/threepp/assessment/Answers/Attachments/Upload/UploadTemplateAttachment';
import Attachments from 'components/threepp/assessment/Answers/Attachments/Attachments';
import TemplateAttachments from 'components/threepp/assessment/Answers/Attachments/TemplateAttachments';
import TemplateDateAnswer from 'components/threepp/assessment/Answers/Date/TemplateDateAnswer';
import TemplateTextAnswer from 'components/threepp/assessment/Answers/Text/TemplateTextAnswer';
import TemplateNumericAnswer from 'components/threepp/assessment/Answers/Numeric/TemplateNumericAnswer';
import TemplateCheckboxAnswer from 'components/threepp/assessment/Answers/Multivalue/TemplateCheckboxAnswer';
import TemplateRadioGroupAnswer from 'components/threepp/assessment/Answers/Option/TemplateRadioGroupAnswer';
import TemplateDropdownAnswer from 'components/threepp/assessment/Answers/Dropdown/TemplateDropdownAnswer';
import { FieldTypes } from 'components/threepp/assessment/Answers/helper';

const Answer = props => {
  const { question, isNewRecord } = props;
  let answerArea = null;

  switch (question.fieldType) {
    case FieldTypes.ATTACHMENT_FIELD:
      answerArea = isNewRecord ? (
        <React.Fragment>
          <UploadTemplateAttachment {...props} />
          <TemplateAttachments {...props} />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <UploadAttachment {...props} />
          <Attachments {...props} />
        </React.Fragment>
      );
      break;
    case FieldTypes.TEXT_FIELD:
      answerArea = isNewRecord ? <TemplateTextAnswer {...props} /> : <TextAnswer {...props} />;
      break;
    case FieldTypes.NUMERIC_FIELD:
      answerArea = isNewRecord ? <TemplateNumericAnswer {...props} /> : <NumericAnswer {...props} />;
      break;
    case FieldTypes.VALUES_LIST_FIELD: {
      const { displayControlType, maximumSelection } = question;

      // Legacy behavior support when displayControlType is not defined
      if (!maximumSelection || maximumSelection > 1) {
        answerArea = isNewRecord ? <TemplateCheckboxAnswer {...props} /> : <CheckboxAnswer {...props} />;
      } else {
        answerArea = isNewRecord ? <TemplateRadioGroupAnswer {...props} /> : <RadioGroupAnswer {...props} />;
      }

      // Support for displayControlType if present
      if (displayControlType === 'CHECKBOXES') {
        answerArea = isNewRecord ? <TemplateCheckboxAnswer {...props} /> : <CheckboxAnswer {...props} />;
      } else if (displayControlType === 'RADIOBUTTONS') {
        answerArea = isNewRecord ? <TemplateRadioGroupAnswer {...props} /> : <RadioGroupAnswer {...props} />;
      } else if (displayControlType === 'DROPDOWNLIST') {
        answerArea = isNewRecord ? <TemplateDropdownAnswer {...props} /> : <DropdownAnswer {...props} />;
      } else if (displayControlType === 'LISTBOX' || displayControlType === 'POPUP') {
        const allowMultipleSelection = maximumSelection !== 1;
        answerArea = isNewRecord ? (
          <TemplateDropdownAnswer {...props} multiple={allowMultipleSelection} />
        ) : (
          <DropdownAnswer {...props} multiple={allowMultipleSelection} />
        );
      }
      break;
    }
    case FieldTypes.DATE_FIELD: {
      answerArea = isNewRecord ? <TemplateDateAnswer {...props} /> : <DateAnswer {...props} />;
      break;
    }
    default:
      answerArea = null;
  }
  return answerArea;
};

Answer.propTypes = {
  // TODO: Fix this...
  // eslint-disable-next-line react/forbid-prop-types
  question: PropTypes.object.isRequired,
  assessmentId: PropTypes.string.isRequired,
  recordId: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
  incrementAttachmentUploadCount: PropTypes.func.isRequired,
  decrementAttachmentUploadCount: PropTypes.func.isRequired,
  isNewRecord: PropTypes.bool,
  uploadingAttachment: PropTypes.bool,
  setUploadingAttachment: PropTypes.func,
  questionId: PropTypes.string
};

export default Answer;
